import type { Editor } from 'slate';
import { Text, Transforms, Node } from 'slate';

export const MAX_LENGTH = 4096;

export function withMaxLengthEditor(editor: Editor) {
  const { normalizeNode } = editor;
  editor.normalizeNode = (entry) => {
    const [node, path] = entry;
    if (Text.isText(node)) {
      const editorString = Node.string(editor);
      const overflowLength = MAX_LENGTH - editorString.length;
      if (overflowLength < 0) {
        const text = node.text.slice(0, overflowLength);
        Transforms.insertText(editor, text, { at: path });
        message.warning(`Max input ${MAX_LENGTH} char.`);
        return;
      }
    }
    normalizeNode(entry);
  };
  return editor;
}
